import RoleHome from '../RoleHome';

export default function MortuaryStaffPage() {
  return (
    <RoleHome
      title="Mortuary staff"
      description="Mortuary records linked to patient context."
    />
  );
}
